<template>
    <div class="vergelijker">
    <subNav :step="step" :subnavstep="subnavstep"></subNav>
    <headerFeedback :count="count"  :slug="slug" :step="step"/>

    <div class="vergelijk-container">
      <div class="vergelijk-container--inner">

        <!-- eerste kolom met democratische waarden, scrolled niet -->
        <div class="vergelijk-legenda">

          <div class="methodeheaders" >
            <template v-for="(div,i) in firstrow">
                <template  v-if="i == 0">
                  <div class="methodes-column methodes-column--first" :key="i">
                    <router-link :to="{ name: 'methodes', params: { doelSlug : slug } }" class="add-button">
                      <span class="label">Voeg een methode toe</span>
                      <span class="icon-plus"></span>
                    </router-link>
                  </div>
                </template>
            </template>
          </div>
          
          <template v-for="(waarde,j) in waardes" >
            <div class="methodewaardes methodewaardes-label"  :key="j" :class="cleanClass(j)">
              <template v-for="(row, i) in waarde">
                <template v-if="i === 0">
                  <div class="methodes-column methodes-column--first" :key="i">
                    <div class="dwaarde-title"  @click="showTips(cleanClass(j))"><span class="text">{{ row }}</span><!--<span class="icon-info"></span>--></div>
                    <div class="fold-down icon-circle-down" @click="showTips(cleanClass(j))"></div>
                  </div>
                </template>
              </template>
            </div>
          </template>

        </div>
      <!-- einde eerste kolom -->

      <!-- Begin overige kolommen met scroll -->
      <div class="vergelijk-values">
        <div class="vergelijk-values--inner">

          <div class="methodeheaders" >
            <template v-for="(div,i) in firstrow">

                <template  v-if="i > 0">
                  <div class="methodes-column" :key="i" >
                    <div class="methodes-column--inner">
                    <span class="closeButton" v-on:click="removeMethod(div.methodid, slug)"></span>
                      <h4>{{ div.titel }}</h4>
                      <p>{{ div.beschrijving  | truncate(80, '...') }}</p>
                    </div>
                  </div>
                </template>

            </template>
          </div>
          
          <template v-for="(waarde,j) in waardes">
            <div class="methodewaardes" :key="j" :class="cleanClass(j)">
              <template v-for="(row, i) in waarde">

                <template v-if="i > 0">
                  <div class="methodes-column" :key="i">
                    <span class="quality-scores">
                      <span class="star" v-for="n in parseInt(row.score)" :key="n"></span>
                      <span class="star star--empty" v-for="n in parseInt(5-row.score)" :key="n+10"></span>
                    </span>
                    <div class="tiptekst" :class="cleanClass(j)">
                      <div v-html="row.tiptekst" class="tiptekst__content"></div>
                      <!-- showDetailMethode(row.methodid) -->
                      <div v-if="row.tiptekst" class="button button--flat" @click="updatelightbox(row)">Lees de tips</div>
                    <!-- <div v-if="row.tiptekst" class="button button--flat" @click="showLightboxMethodeTips(row)">Lees de tips</div> -->
                    </div>
                  </div>
                </template>

              </template>
            </div>
          </template>

        </div>
      </div>
      <!-- einde overige kolommen met scroll -->

      </div>
  
    </div>

    <div class="page-footer">
      <router-link :to="{ name: 'methodes', params: { doelSlug : slug } }" class="button">Terug naar overzicht</router-link>
      <router-link :to="{ name: 'tussenschermResultaat'}" class="button">Zet methodes (<span class="methodes_selection_count">{{ count }}</span>) in uw resultaat</router-link>
    </div>

    <!-- lightbox -->
    <div id="lightboxLarge" class="lightbox">
      <div class="lightbox-inner">
          <span class="lightbox-close icon-close" @click="hideLightbox2()"></span>
          <div class="lightbox-inner--content" id="lightbox-content">
            <methodeLightbox 
              :method="methodeID" 
              :waarde="waardeindex" 
              :methode="methode"
              :tipsArray="tipsArray">
            </methodeLightbox>
          </div>
      </div>
    </div>
    <!-- end lightbox -->

  </div>
</template>

<script>
import subNav from '../components/subNav.vue';
import headerFeedback from '../components/headerFeedback.vue';
import methodeLightbox from './methodeLightbox.vue';

const ENDPOINT_NAME = 'ppw/v1/comparemethodes';
const ENDPOINT_DETAIL = 'ppw/v1/methode';

const axios = require('axios');

export default {
  name: "vergelijkMethodes",

  data() {
    return {
      isLoading: true,
      isEmptyResult: false,
      // bevat alle info over de methodes voor firstrow en waardes:
      methodes: [],
      storeMethods: [],
      firstrow: [],
      waardes: [],
      step: 'vergelijking', 
      subnavstep: 'methodes',
      schermtitel: '',
      schermtekst: '',
      count: 0,
      doel: '',
      slug: '',
      index: 0,
      pushers: [],
      teller: 0,
      methods: '',
      name: 'World',
      // data for methodeDetailLightbox
      methode: {},
      methodeID: 0,
      waardeindex: 0,
      tipsArray: [],
      hiddenTips: [],
    };

   },

  components: {
    subNav,
    headerFeedback,
    methodeLightbox,
  },

  computed: {
    
  },
  
  methods: {

    compareMethods: function(slug,methods) {
      const url = new URL(process.env.VUE_APP_REST_URL + ENDPOINT_NAME + '?doelSlug=' + slug + '&methods=' + methods);
      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios.get(url)
        .then(r => {
          const results = r.data;
          if (!results) {
            this.methodes = [];
            this.isEmptyResult = true;
          } else {
            this.doel = r.data.doel;
            this.slug = r.data.slug;
            this.index = r.data.index;
            this.methodes = r.data.methodes;
            this.firstrow = r.data.firstrow;
            this.waardes = r.data.waardes;
            this.count = parseInt(r.data.count);
            this.methodeID = this.methodes[0].id
            this.setMethodeDetail(this.methodeID,this.waardeindex)
          }
        })
        .catch(error => {
          console.warn(error);
        })
    },

    updatelightbox(row) {
      this.setMethodeDetail(row.methodid,row.waardeindex)
      document.getElementById('lightboxLarge').classList.toggle("active");
    },

    setMethodeDetail(id,waarde) {
      const url = new URL(process.env.VUE_APP_REST_URL + ENDPOINT_DETAIL + '?method='+id);
      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios.get(url)
        .then(r => {
          const results = r.data
          if (!results) {
            this.methode = {}
            this.isEmptyResult = true
          } else {
            this.methodeID   = id
            this.waardeindex = waarde
            this.methode     = r.data.methode
            this.tipsArray   = this.getTips(this.methode, waarde)
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },

    hideLightbox2: function () {
      // Hide Lightbox
      document.getElementById('lightbox2').classList.toggle("active");
      
      // Empty Lightbox
      let lightboxContent = document.getElementById('lightbox-content');
    },

    getTips: function (method, waardeidx) {
      let holdTips = []

      // dit toont de tips bij een democratische waarde
      if (method.values[waardeidx].tips) {

        holdTips['method'] = method.name_short
        holdTips['waarde'] = method.values[waardeidx].waarde
        holdTips['beschrijving'] = method.values[waardeidx].tekst
        holdTips['tips'] = []

        let tipsArray = method.values[waardeidx].tips;
        let tipsLength = method.values[waardeidx].tips.length;

        if (localStorage.getItem('hiddenTips')) 
          this.hiddenTips = JSON.parse(localStorage.getItem('hiddenTips'))
        else
          this.hiddenTips = []

        for(var i = 0; i < tipsLength; i++) {
          let thistip = []
          let tipIsChecked = true
          let tipIdasString = tipsArray[i].id.toString()
          if (this.hiddenTips) {
            if (this.hiddenTips.indexOf(tipIdasString) > -1) {
              tipIsChecked = false
            }
          }
          thistip['checkboxvalue'] = 'tipcheck_' + tipsArray[i].id
          thistip['id'] = tipsArray[i].id
          thistip['value'] = tipsArray[i].value
          thistip['checked'] = tipIsChecked
          holdTips['tips'][i] = thistip
        }
        return holdTips;
      }
    },

    hideLightbox2: function () {
      // Hide Lightbox
      document.getElementById('lightboxLarge').classList.toggle("active");
    },

    excerpt(txt) {
      return txt.substring(0, 150) + ' ...'
    },


    showTips: function (classname) {

      const targetRow = document.getElementsByClassName(classname);

      // get the heights from all the tip teksten divs and put them in an array, sort by size 
      const tipTeksten = document.getElementsByClassName('tiptekst '+ classname)
      let tipHeigtArray = []
      for (let item of tipTeksten) {
         tipHeigtArray.push(item.clientHeight);
      }
      tipHeigtArray.sort(function(a, b){return b - a});
      let newHeight = tipHeigtArray[0] + 70/// highest height + 

      // add active classes and heights to div
      for (let item of targetRow) {
         item.classList.toggle("active");
      }
      targetRow[0].style.height = newHeight+"px";
    },

    cleanClass(j) {
      return 'row_'+j.replace(/ \/ /g, '');
    },

    removeMethod(i,s) {
      // remove methodeid from methods in storeMethods
      let idx = 0
      for (let r = 0; r < this.storeMethods.length; r++) {
        if (this.storeMethods[r].slug == s)
          idx = r
      }
      this.storeMethods[idx].methods.splice(this.storeMethods[idx].methods.indexOf(i), 1);

      // localstorage
      const parsed = JSON.stringify(this.storeMethods);
      localStorage.setItem('comparedItems', parsed);

      // call compareMethods again
      setTimeout(() => this.compareMethods(this.slug,this.methods), 50)

    }
  },

  created() {
    this.slug = this.$route.params.doelSlug
    // ok, zit dit doel al in de localstorage?
    this.storeMethods = JSON.parse(localStorage.getItem('comparedItems'))
    for (let i = 0; i < this.storeMethods.length; i++) {
      if (this.storeMethods[i].slug == this.slug)
        this.methods  = this.storeMethods[i].methods
    }
    setTimeout(() => this.compareMethods(this.slug,this.methods), 50)
  },

  mounted() {
  }
};

</script>

